import * as React from 'react'
import { graphql } from 'gatsby'
import CustomHead from '../components/CustomHead'
import { SITE_URL } from '../constants'
import CustomHeader from '../components/CustomHeader'
import { QuarterlyStories } from '../components/QuarterlyStories'
import { css } from 'emotion'
import { Footer } from '../components/Footer'

export const query = graphql`
  query {
    issues {
      issues {
        term
        coverphoto
        articles
      }
    }
    allPrimeArticle {
      edges {
        node {
          slug
          headline
          author
          authorbio
          authoremail
          authortwitter
          coverimg
          covercred
          coveralt
          articleType
          excerpt
        }
      }
    }
  }
`
const AllStories = ({ data }) => {
  let quarterlyStories = data.issues.issues.map(issue => {
    let term = issue.term
    let season = term.substring(0, term.length - 2)
    let year = '20' + term.substring(term.length - 2, term.length)
    return {
      quarter: season + ' ' + year,
      stories: issue.articles
        .map(slug => {
          const curredge = data.allPrimeArticle.edges.filter(edge => {
            return edge.node.slug === slug
          })[0]
          return curredge?.node  // optional chaining instead of crashing
        })
        .filter(node => node !== undefined)  // drop the ones that didn't match,
    }
  })
  return (
    <>
      <CustomHead
        siteName="PRIME"
        pageName="all stories"
        url={`${SITE_URL}/all`}
        description="PRIME is the official website for the Daily Bruin's quarterly arts, culture and lifestyle magazine."
        image="https://assets.dailybruin.com/images/sabrina.whensoundshurt/cover-83530e07fd73cf3d7e1c8b5a85639df2.jpg"
      />
      <div>
        <CustomHeader />
        <div
          className={css`
            margin: 20px;
            margin-top: 50px;
            margin-bottom: 100px;
          `}
        >
          <QuarterlyStories quarters={quarterlyStories} />
        </div>
        <Footer />
      </div>
    </>
  )
}

export default AllStories
